// ABOUTME: Defines TechLog fuel TypeScript domain types.
export enum TechlogTruckUnit {
  LITER = 'l',
  US_GALLON = 'usg',
}
